import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import { Box, Fade, Modal, Stack, Typography } from "@mui/material"
import CELEBRATE_IMG from 'Components/Elements/ResetPassword/Assets/success.svg'

const UpdatePasswordSuccessModal = ({
    isShowModal,
    onClickOK
}) => {

    return (
        <Modal
            open={isShowModal}
            closeAfterTransition
            sx={{
                '*': {
                    boxSizing: 'border-box!important',
                }
            }}
        >
            <Fade
                in={isShowModal}
                timeout={800}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        padding: '24px',
                        transform: 'translate(-50%, -50%)',
                        width: 'calc(100% - 32px)',
                        maxWidth: '798px',
                        backgroundColor: '#fff',
                        borderRadius: '12px',

                        "@media (min-width: 768px)": {
                            top: '40%',
                            padding: '40px'
                        },

                        ':focus-visible': {
                            outline: 'none'
                        }
                    }}
                >
                    {/* Celebrate Image */}
                    <Stack
                        sx={{
                            mb: '25px'
                        }}
                    >
                        <Stack
                            sx={{
                                width: '30px',
                                height: 'auto',
                                objectFit: 'contain',
                            }}
                        >
                            <img src={CELEBRATE_IMG} alt={'CELEBRATE_IMG'} width={"100%"} height={"100%"} />
                        </Stack>

                    </Stack>

                    {/* Content */}
                    <Stack
                        sx={{
                            mb: '25px'
                        }}
                    >
                        <Stack>
                            <Typography
                                sx={{
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    color: '#0B3B61',
                                    fontFamily: 'Poppins, NotoSansThai, sans-serif!important',
                                    mb: '12px',
                                    lineHeight: '30px',
                                }}
                            >
                                <T>password_updated</T>
                            </Typography>
                        </Stack>

                        <Stack>
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#003B6F',
                                    fontFamily: 'Inter, NotoSansThai, sans-serif!important',
                                    lineHeight: '26px',
                                }}
                            >
                                <T>update_password_success_desc</T>
                            </Typography>
                        </Stack>
                    </Stack>

                    {/* Button */}
                    <Stack>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#5A8FC3',
                                fontFamily: 'Inter, NotoSansThai, sans-serif!important',
                                lineHeight: '29px',
                                textDecoration: 'underline',
                                textDecorationStyle: 'solid',
                                cursor: 'pointer',
                                textUnderlinePosition: 'from-font',
                                textUnderlineOffset: '3px',
                            }}
                            onClick={onClickOK}
                        >
                            <T>ok</T>
                        </Typography>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    )
}

export default UpdatePasswordSuccessModal